












































































import Component, { mixins } from "vue-class-component";
import AxiosMixin from "@/mixins/axiosMixin";
import LoadingDialog from "@/components/common/LoadingDialog.vue";
import {
  MedicalSpecification,
  MedicalInvoice
} from "@/components/medicalTransmissionEdit/types";
import { SelectItem, PulldownItem, SelectItemString } from "@/types";
import MedicalTransmissionRev1 from "@/components/medicalTransmissionEdit/specification/MedicalTransmissionRev1.vue";
import MedicalTransmissionRev2 from "@/components/medicalTransmissionEdit/specification/MedicalTransmissionRev2.vue";
import MedicalInvoiceRev1 from "@/components/medicalTransmissionEdit/invoice/MedicalInvoiceRev1.vue";

@Component({
  components: {
    LoadingDialog,
    MedicalTransmissionRev1,
    MedicalTransmissionRev2,
    MedicalInvoiceRev1
  }
})
export default class MedicalTransmissionEdit extends mixins(AxiosMixin) {
  private specifications: MedicalSpecification[] = []; //医療給付費データ
  private invoices: MedicalInvoice[] = []; //利用者向け請求書データ
  private selectTabItem = 0; //選択中のタブ
  private specification_component_name = ""; //明細のコンポーネント名

  //マスタ
  private ins_type_items: PulldownItem[] = []; //保険種類アイテムリスト
  private ins_multi_items: PulldownItem[] = []; //保険併用アイテムリスト
  private ins_div_items: PulldownItem[] = []; //保険区分アイテムリスト
  private public_option_divs: SelectItemString[] = []; //任意給付区分
  private sex_items: SelectItem[] = []; //性別選択アイテムリスト
  private receipt_special_codes: SelectItemString[] = []; //レセプト特記コード
  private readmission_category_codes: SelectItemString[] = []; //再入院等区分コード
  private partial_payment_category_codes: SelectItemString[] = []; //一部負担金区分コード
  private occupational_reason_codes: SelectItemString[] = []; //職務上の事由コード
  private payer_type_codes: SelectItemString[] = []; //負担者種別コード
  private confirmation_category_codes: SelectItemString[] = []; //確認区分コード
  private prefecturess: PulldownItem[] = []; //都道府県コード
  private prefectures_strings: SelectItemString[] = []; //都道府県コード（string版）
  private list_marks_codes: SelectItemString[] = []; //点数表コード
  private patient_information_codes: SelectItemString[] = []; //利用者情報コード
  private location_codes: SelectItemString[] = []; //場所コード
  private end_visit_status_codes: SelectItemString[] = []; //訪問終了の状況コード
  private beppyou_items: SelectItem[] = []; //別表選択アイテムリスト
  private specialty_training_codes: SelectItemString[] = []; //専門の研修コード

  private burden_category_codes: SelectItemString[] = []; //負担区分コード（画面用）
  private occupation_codes: SelectItemString[] = []; //職種等コード
  private visit_frequency_codes: SelectItemString[] = []; //訪問看護回数コード
  private instruction_classification_codes: SelectItemString[] = []; //指示区分コード

  private medical_examination_classification_codes: PulldownItem[] = []; //受診等区分コード

  private reduction_unit_items: SelectItem[] = []; //減額単位アイテムリスト
  private exemption_category_codes: SelectItem[] = []; //減免区分コード
  private customer_amount_codes: SelectItemString[] = []; //窓口負担額区分コード
  private isTrial = window.is_trial;

  mounted() {
    this.updateData();
  }

  //データ取得
  private updateData() {
    this.postJsonCheck(
      window.base_url + "/api/office/medical/transmission/edit/get",
      {
        patient_id: Number(this.$route.params.id),
        patient_name: String(this.$route.query.patient_name),
        specification_id: Number(this.$route.query.specification_id),
        yearmonth: this.$route.query.yearmonth
      },
      res => {
        this.specifications = res.data.specifications;
        this.invoices = res.data.invoices;
        this.selectTabItem = res.data.select_tab;
        this.specification_component_name =
          res.data.specification_component_name;

        this.ins_type_items = res.data.ins_type_items;
        this.ins_multi_items = res.data.ins_multi_items;
        this.ins_div_items = res.data.ins_div_items;
        this.public_option_divs = res.data.public_option_divs;
        this.sex_items = res.data.sex_items;
        this.receipt_special_codes = res.data.receipt_special_codes;
        this.readmission_category_codes = res.data.readmission_category_codes;
        this.partial_payment_category_codes =
          res.data.partial_payment_category_codes;
        this.occupational_reason_codes = res.data.occupational_reason_codes;
        this.payer_type_codes = res.data.payer_type_codes;
        this.confirmation_category_codes = res.data.confirmation_category_codes;
        this.prefecturess = res.data.prefecturess;
        this.prefectures_strings = res.data.prefectures_strings;
        this.list_marks_codes = res.data.list_marks_codes;
        this.patient_information_codes = res.data.patient_information_codes;
        this.location_codes = res.data.location_codes;
        this.end_visit_status_codes = res.data.end_visit_status_codes;
        this.beppyou_items = res.data.beppyou_items;
        this.specialty_training_codes = res.data.specialty_training_codes;

        this.burden_category_codes = res.data.burden_category_codes;
        this.occupation_codes = res.data.occupation_codes;
        this.visit_frequency_codes = res.data.visit_frequency_codes;
        this.instruction_classification_codes =
          res.data.instruction_classification_codes;

        this.medical_examination_classification_codes =
          res.data.medical_examination_classification_codes;

        this.reduction_unit_items = res.data.reduction_unit_items;
        this.exemption_category_codes = res.data.exemption_category_codes;
        this.customer_amount_codes = res.data.customer_amount_codes;
      }
    );
  }

  //キャンセル
  private cancel() {
    this.$router.go(-1);
  }

  //保存
  private save() {
    if (!confirm("データを保存しますか？")) {
      return;
    }
    this.postJsonCheck(
      window.base_url + "/api/office/medical/transmission/edit/update",
      {
        pre_specifications: this.specifications,
        pre_invoices: this.invoices
      },
      () => {
        this.cancel();
      }
    );
  }
}
